import { Enum, EnumType } from 'ts-jenum';

@Enum<PresentationType>('value')
export class PresentationType extends EnumType<PresentationType>() {
   public static readonly ICON_AND_TEXT = new PresentationType('ICON_AND_TEXT', true, true, 'common.types.presentation_type.icon_and_text');
   public static readonly ICON_ONLY = new PresentationType('ICON_ONLY', true, false, 'common.types.presentation_type.icon_only');
   public static readonly TEXT_ONLY = new PresentationType('TEXT_ONLY', false, true, 'common.types.presentation_type.text_only');

   private constructor(public value: string, public showIcon: boolean, public showText: boolean, public translationKey: string) {
      super();
   }
}
